import { render, staticRenderFns } from "./Infinity.vue?vue&type=template&id=ee4797a8&scoped=true&"
var script = {}
import style0 from "./Infinity.vue?vue&type=style&index=0&id=ee4797a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4797a8",
  null
  
)

export default component.exports